import { Close, CreditCard, LocalAtm, LocationOn } from "@mui/icons-material";
import { Button, Rating } from "@mui/material";
import { database } from "configs/firebaseConfigs";
import { useAppContext } from "contexts";
import { ref, remove } from "firebase/database";
import React from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const DistributorCards = (props) => {
  const { user } = useAppContext();

  const removeWishlist = async () => {
    try {
      console.log("remove");
      await remove(ref(database, `wishlist/${user?.uid}/${props?.id}`));
      Swal.fire({
        title: "Supplier Removed from Wishlist",
        icon: "success",
      });
    } catch (error) {
      console.log(error);
    }
  };
  // console.log(props);
  return (
    <div className="distributor-child-outer flex-row justify-content-center ">
      <div className="distributor-card-child flex-column gap-2">
        <div className="distributor-card-left flex-row align-items-center ">
          {props?.inWishlist && (
            <div className="distributor-card-fav-btn">
              <Button onClick={removeWishlist}>
                <Close />
              </Button>
            </div>
          )}
          <img src={props.img} alt="Supplier" />
        </div>

        <div className="distributor-card-right flex-column align-items-center">
          <div className="distributor-card-rating flex-row gap-1 align-items-center ">
            <Rating name="read-only" value={parseInt(props.rating)} readOnly />
            {props?.totalRating && <span>({props?.totalRating})</span>}
          </div>
          <div className="distributor-card-name">
            <h1 className="htdn">{props.name}</h1>
          </div>
          <div className="distributor-card-location ">
            <p className="flex-row align-items-center">
              <LocationOn /> {props.location}
            </p>
          </div>

          <div className="distributor-card-min-order">
            <p>Min Order : SAR {props.minOrder}</p>
          </div>

          <div className="payments-details-card">
            {props.payments && (
              <p className=" flex-row align-items-center ">
                {props.payments?.cash && (
                  <span className="flex-row align-items-center">
                    <LocalAtm />
                  </span>
                )}
                {props.payments?.card && (
                  <span className="flex-row align-items-center">
                    <CreditCard />
                  </span>
                )}
              </p>
            )}
          </div>
          <div className="distributor-card-order-now">
            <Link to={`/supplier/${props.id}`}>
              <Button className="distributor-card-order-now-btn">
                Order Now
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistributorCards;
